import * as React from "react";
import { useState } from "react";
import { Outlet, useNavigate } from "react-router";
import Tabcontainer from "../components/Tabcontainer";
import HeaderMain from "../components/Headermain";
import { Box, Container } from "@mui/joy";

export default function TabIndex() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  return (
    <Box pb={15}>
      <HeaderMain />
      <Container>
      <Outlet />
      </Container>
     

      <Tabcontainer />
    </Box>
  );
}
